import React from "react";
import { BsEye } from "react-icons/bs";
import { Link } from "react-router";
import NavigationButtons from "../../../components/NavigationButtons";

const SchoolDetails = () => {
  const SupervisorData = [
    {
      supervisorName: "Ahmed Ali",
      inProgressActivities: 7,
      completedActivities: 2,
      gradedEssays: 2,
      feedbackRequests: 4,
      feedbackGiven: 1,
    },
    {
      supervisorName: "John Doe",
      inProgressActivities: 4,
      completedActivities: 3,
      gradedEssays: 4,
      feedbackRequests: 2,
      feedbackGiven: 6,
    },
    {
      supervisorName: "John Doe",
      inProgressActivities: 4,
      completedActivities: 3,
      gradedEssays: 5,
      feedbackRequests: 8,
      feedbackGiven: 4,
    },
    {
      supervisorName: "John Doe",
      inProgressActivities: 4,
      completedActivities: 3,
      gradedEssays: 7,
      feedbackRequests: 4,
      feedbackGiven: 3,
    },
    {
      supervisorName: "John Doe",
      inProgressActivities: 6,
      completedActivities: 4,
      gradedEssays: 4,
      feedbackRequests: 8,
      feedbackGiven: 5,
    },
    {
      supervisorName: "John Doe",
      inProgressActivities: 9,
      completedActivities: 6,
      gradedEssays: 6,
      feedbackRequests: 5,
      feedbackGiven: 5,
    },
    {
      supervisorName: "John Doe",
      inProgressActivities: 3,
      completedActivities: 1,
      gradedEssays: 4,
      feedbackRequests: 7,
      feedbackGiven: 3,
    },
  ];

  return (
    <div className="">
      <div className=" w-full flex flex-col p-8">
        {/* details */}
        <div className="w-full bg-r400 flex gap-8 items-center mt-8 relative ">
          <p className="absolute bg-white text-2xl font-medium -top-6 left-8 p-2">
            School Details
          </p>
          <div className=" flex items-center gap-12 border w-1/2 rounded-lg border-gray-400 h-[350px] p-8 text-nowrap">
            <div>
              <div className="flex items-center justify-between">
                <div className="flex flex-col text-[20px]">
                  <p className="text-gray-600">School Name:</p>
                  <p className="text-gray-700">12</p>
                </div>
              </div>

              <div className="flex items-center justify-between mt-4">
                <div className="flex flex-col text-[20px]">
                  <p className="text-gray-600">Activity Start Date:</p>
                  <p className="text-gray-700">128</p>
                </div>
              </div>

              <div className="flex items-center justify-between mt-4">
                <div className="flex flex-col text-[20px]">
                  <p className="text-gray-600">Total Number of Supervisors:</p>
                  <p className="text-gray-700">12</p>
                </div>
              </div>

              <div className="flex items-center justify-between mt-4">
                <div className="flex flex-col text-[20px]">
                  <p className="text-gray-600">Average Students</p>
                  <p className="text-gray-700">12</p>
                </div>
              </div>
            </div>
            <div className="space-y-4 ">
              <div className="flex flex-col text-[20px]">
                <p className="text-gray-600">Regions</p>
                <p className="text-gray-700">4</p>
              </div>
              <div className="flex flex-col text-[20px]">
                <p className="text-gray-600">Activity End Date:</p>
                <p className="text-gray-700">4</p>
              </div>
              <div className="flex flex-col text-[20px]">
                <p className="text-gray-600">Below Average Students</p>
                <p className="text-gray-700">4</p>
              </div>
              <div className="flex flex-col text-[20px]">
                <p className="text-gray-600">Above Average Students</p>
                <p className="text-gray-700">4</p>
              </div>
            </div>
          </div>

          <div className="border w-1/2 rounded-lg border-gray-400 h-[350px] p-8 relative">
            <p className="absolute bg-white text-2xl font-medium -top-6 left-8 p-2">
              Submission Analytics
            </p>

            <div className="flex flex-col items-center gap-6">
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who received the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>{" "}
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who participated in the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who completed the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of students who didn’t started the Activity:
                </p>
                <p className="text-gray-700">12</p>
              </div>
              <div className="flex flex-items justify-between w-full  text-[20px] ">
                <p className="text-gray-600">
                  Number of submissions that have been graded:
                </p>
                <p className="text-gray-700">12</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white border-gray-400 rounded-lg border-2 w-full mt-8 relative p-4">
          <p className="absolute bg-white text-2xl font-medium -top-8 left-8 p-2">
            Supervisors
          </p>

          <div className="overflow-x-auto">
            <table className="w-full items-center">
              <thead className="text-[16px] font-medium">
                <tr className="">
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Supervisor Name
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    In-Progress Activities
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Completed Activities
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Graded Essays
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Feedback Requests
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Feedback Given
                  </th>
                  <th className="px-4 py-3 text-left  text-gray-700 font-semibold">
                    Options
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-400">
                {SupervisorData.map((supervisor, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 whitespace-nowrap">
                      {supervisor.supervisorName}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {supervisor.inProgressActivities}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {supervisor.completedActivities}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {supervisor.gradedEssays}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {supervisor.feedbackRequests}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {supervisor.feedbackGiven}
                    </td>
                    <td className=" py-3 whitespace-nowrap">
                      <Link to={"/admin/in-progress-activities"}>
                        <button className=" flex items-center justify-center gap-1 bg-blue-600 text-white px-3 py-1 rounded-lg text-sm">
                          <BsEye />
                          View Details
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="flex justify-between w-full gap-4">
        <div className="m-2">
          <NavigationButtons />
        </div>
      </div>
    </div>
  );
};

export default SchoolDetails;
